import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../builder';
import { CTAClickTracking } from './CTAClickTracking';

export default createBuilderModule(withChildren(CTAClickTracking), {
  name: 'CTAClickTracking',
  image: 'https://cdn.zappy.app/d686bf40f1aa0706d104ed34eedb946b.png',
  inputs: [
    {
      name: 'sectionName',
      type: 'string',
    },
  ],
  childRequirements: {
    message:
      'Children of the Click Tracking component must be a built-in component from the Basics section',
    query: {
      'component.name': {
        $in: [
          'Core:Button',
          'Core:Text',
          'Core:Image',
          'Core:Columns',
          'Core:Box',
          'Core:Section',
        ],
      },
    },
  },
});
